import { BaseHit, Widget } from 'instantsearch.js';
import BaseTypesenseSearch from '../typesense-search';
import {
  refinementstemplateRenderer,
  getRefinements,
  getCurrentRefinements,
  getHits,
  getStats,
  getPagination,
  getClearRefinements,
} from '../common-widgets';
import { HitsTemplates } from 'instantsearch.js/es/widgets/hits/hits';
import { configure } from 'instantsearch.js/es/widgets';

interface IPortraitAdherent {
    id: string;
    title: string;
    excerpt: string;
    thumbnail: {
        url: string;
        width: number;
        height: number;
    } | null;
    permalink: string;
    type_de_serie: string[];
    region: string[];
    episode: number;
    syndicat: string[];
    taille_entreprise: string[];
    nom: string;
    prenom: string;
    fonction: string;
    adresse_entreprise: string;
}

export default class PortraitAdherent extends BaseTypesenseSearch {
  private resultHitsContainer: HTMLDivElement | null = null;
  private refinementsContainerTypeDeSerie: HTMLDivElement | null = null;
  private refinementsContainerRegion: HTMLDivElement | null = null;
  private refinementsContainerSyndicat: HTMLDivElement | null = null;
  private refinementsContainerTailleEntreprise: HTMLDivElement | null = null;
  private currentRefinementsContainer: HTMLDivElement | null = null;
  private clearRefinementsContainer: HTMLDivElement | null = null;
  private statsContainer: HTMLDivElement | null = null;
  private paginationContainer: HTMLDivElement | null = null;
  private excludedIds: (string | number)[] = [];

  constructor() {
    super();
  }

  getHitTemplates(): HitsTemplates {
    return {
      item(data, { html }) {
        const {
          title,
          thumbnail,
          permalink,
          episode,
          syndicat,
          nom,
          prenom,
          fonction,
          nom_entreprise,
        } = data as unknown as BaseHit & IPortraitAdherent;
        const fonctionText = `${fonction} ${nom_entreprise ? `, ${nom_entreprise}` : ''}`;

        let image = html`
          <div class="card-image card-image-placeholder" aria-hidden="true">
          <span class="card-image-placeholder-logo">
            <svg width="128" height="128" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.02693 18.329C4.18385 19.277 5.0075 20 6 20H18C19.1046 20 20 19.1046 20 18V14.1901M4.02693 18.329C4.00922 18.222 4 18.1121 4 18V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V14.1901M4.02693 18.329L7.84762 14.5083C8.52765 13.9133 9.52219 13.8482 10.274 14.3494L10.7832 14.6888C11.5078 15.1719 12.4619 15.1305 13.142 14.5865L15.7901 12.4679C16.4651 11.9279 17.4053 11.8856 18.1228 12.3484C18.2023 12.3997 18.2731 12.4632 18.34 12.5302L20 14.1901M11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
           </span>
          </div>
        `;

        if (thumbnail?.height) {
          image = html`
            <img
                width="${thumbnail.width}" height="${thumbnail.height}"
                src="${thumbnail.url}"
                class="attachment-card-image size-card-image" alt="" loading="lazy"
            />
          `;
        }

        return html`
            <a
                href="${permalink}"
                class="card card-portrait card-link"
                style="--card-background-color: #551571;"
                title="${title}"
            >
                <div class="card-tags-content">
                    <span class="card-tag ontitle">${syndicat?.length ? syndicat[0] : ''}</span>
                    <span class="card-tag ontitle">Épisode ${episode}</span>
                </div>
                <div class="card-image wrapper-image">${image}</div>
                <div class="card-content">
                <h3 class="card-title">${title}</h3>
                <div class="card-text-wrapper">
                    <div class="card-text">
                        <p>${prenom} ${nom}</p>
                        <span class="fonction">${fonctionText}</span>
                    </div>
                    <span class="btn btn-simple btn-primary">
                    Voir l’épisode
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M1.33319 10.0001L1.3331 8.6668H12.1144L9.48123 6.03363L10.424 5.09082L14.6667 9.33347L10.424 13.5761L9.48123 12.6333L12.1144 10.0001L1.33319 10.0001Z"
                            fill="currentColor"></path>
                    </svg>
                    </span>
                </div>
                </div>
            </a>
        `;
      },
    };
  }

  getWidgets() {
    return [
      this.resultHitsContainer ? getHits(this.resultHitsContainer, undefined, this.getHitTemplates()) : null,
      this.refinementsContainerTypeDeSerie ? getRefinements(this.refinementsContainerTypeDeSerie, 'type_de_serie', refinementstemplateRenderer) : null,
      this.refinementsContainerRegion ? getRefinements(this.refinementsContainerRegion, 'region', refinementstemplateRenderer) : null,
      this.refinementsContainerSyndicat ? getRefinements(this.refinementsContainerSyndicat, 'syndicat', refinementstemplateRenderer) : null,
      this.refinementsContainerTailleEntreprise ? getRefinements(this.refinementsContainerTailleEntreprise, 'taille_entreprise', refinementstemplateRenderer) : null,
      this.statsContainer ? getStats(this.statsContainer) : null,
      this.currentRefinementsContainer ? getCurrentRefinements(this.currentRefinementsContainer, null) : null,
      this.paginationContainer ? getPagination(this.paginationContainer) : null,
      this.clearRefinementsContainer ? getClearRefinements(this.clearRefinementsContainer) : null,
      this.configureParams ? configure(this.configureParams) : null,
    ].filter(Boolean) as Widget[];
  }


  init() {
    this.resultHitsContainer = this.querySelector('.result-hits');
    this.refinementsContainerTypeDeSerie = this.querySelector('.refinements-type-de-serie');
    this.refinementsContainerRegion = this.querySelector('.refinements-region');
    this.refinementsContainerSyndicat = this.querySelector('.refinements-syndicat');
    this.refinementsContainerTailleEntreprise = this.querySelector('.refinements-taille');
    this.currentRefinementsContainer = this.querySelector('.current-refinements');
    this.clearRefinementsContainer = this.querySelector('.clear-refinements');
    this.statsContainer = this.querySelector('.search-stats');
    this.paginationContainer = this.querySelector('.search-pagination');

    this.searchInstance?.start();
    this.searchInstance?.addWidgets(this.getWidgets());
  }

  connectedCallback() {
    setTimeout(() => {
      super.initSearchInstance();
      this.init();
    });
  }
}
